let axios = require('axios')

module.exports = {
  postEmail: (email) => {
    axios.post('https://ln2uwgr3u0.execute-api.us-east-1.amazonaws.com/prod/StoreEmailPG', {
      'email': email
    }).then(response => {}).catch(e => {
      console.log(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/api.js